class Contact {
  init () {
    const contactForm = $('#contact-form')
    const formId = contactForm.data('form-id')

    if (contactForm) {
      // hbspt.forms.create({
      //   region: 'eu1',
      //   portalId: '25386520',
      //   formId: formId
      // }, {
      //   target: '#contact-form'
      // })
    }
  }
}

export default Contact
